import React, { useContext, useEffect, useState } from 'react';
import { Grid, Card, CardContent, Typography, CircularProgress, Box } from '@mui/material';
import SidebarContext from '../../component/sidebarcontext/SidebarContext';
import CryptoJS from "crypto-js";
import { AccountBalance, CreditCard, People, Receipt, Sms, TrendingUp, DashboardCustomizeRounded } from '@mui/icons-material';

const Dashboard = () => {
  const apisignature = process.env.REACT_APP_SIGNATURE;
  const { url } = useContext(SidebarContext);
  const [loading, setLoading] = useState(true);
  const userinfo = JSON.parse(localStorage.getItem("userInfo"));
  const [dashboardList, setDashboardList] = useState({});

  const cardData = [
    {
      id: 1,
      title: "No. of Customers",
      value: dashboardList.numOfCustomer ?? "0",
      icon: <People sx={{ fontSize: 24, color: "white" }} />,
      largeIcon: <People sx={{ fontSize: 60, color: "white" }} />,
      background: "linear-gradient(135deg, #0ea5e9 0%, #0369a1 100%)", // cyan/blue
      boxShadow: "0 8px 16px rgba(14,165,233,0.3)",
      hoverShadow: "0 12px 24px rgba(14,165,233,0.45)",
    },
    {
      id: 2,
      title: "No. of Transactions",
      value: dashboardList.numOfTxn ?? "0",
      icon: <Receipt sx={{ fontSize: 24, color: "white" }} />,
      largeIcon: <Receipt sx={{ fontSize: 60, color: "white" }} />,
      background: "linear-gradient(135deg, #f59e0b 0%, #b45309 100%)", // amber
      boxShadow: "0 8px 16px rgba(245,158,11,0.3)",
      hoverShadow: "0 12px 24px rgba(245,158,11,0.45)",
    },
    {
      id: 3,
      title: "Credit Limit Remaining",
      value: dashboardList.coOperativeCreditLimit
        ? `रू ${dashboardList.coOperativeCreditLimit}`
        : "रू 0.00",
      icon: <CreditCard sx={{ fontSize: 24, color: "white" }} />,
      largeIcon: <CreditCard sx={{ fontSize: 60, color: "white" }} />,
      background: "linear-gradient(135deg, #6366f1 0%, #312e81 100%)", // indigo
      boxShadow: "0 8px 16px rgba(99,102,241,0.3)",
      hoverShadow: "0 12px 24px rgba(99,102,241,0.45)",
    },
    {
      id: 4,
      title: "Total Commission Earned",
      value: dashboardList.totalCommEarned
        ? `रू ${dashboardList.totalCommEarned}`
        : "रू 0.00",
      icon: <TrendingUp sx={{ fontSize: 24, color: "white" }} />,
      largeIcon: <TrendingUp sx={{ fontSize: 60, color: "white" }} />,
      background: "linear-gradient(135deg, #10b981 0%, #064e3b 100%)", // emerald
      boxShadow: "0 8px 16px rgba(16,185,129,0.3)",
      hoverShadow: "0 12px 24px rgba(16,185,129,0.45)",
    },
    {
      id: 5,
      title: "Total SMS Sent",
      value: dashboardList.totalNumOFSmsSent ?? "0",
      icon: <Sms sx={{ fontSize: 24, color: "white" }} />,
      largeIcon: <Sms sx={{ fontSize: 60, color: "white" }} />,
      background: "linear-gradient(135deg, #f43f5e 0%, #881337 100%)", // rose
      boxShadow: "0 8px 16px rgba(244,63,94,0.3)",
      hoverShadow: "0 12px 24px rgba(244,63,94,0.45)",
    },
    {
      id: 6,
      title: "No. of Fund Transfers",
      value: dashboardList.numFundTransfer ?? "0",
      icon: <AccountBalance sx={{ fontSize: 24, color: "white" }} />,
      largeIcon: <AccountBalance sx={{ fontSize: 60, color: "white" }} />,
      background: "linear-gradient(135deg, #89648b 0%, #70306d 100%)", // purple/charcoal
      boxShadow: "0 8px 16px rgba(100,116,139,0.3)",
      hoverShadow: "0 12px 24px rgba(100,116,139,0.45)",
    },
  ];

  useEffect(() => {
    getDashboardList();
  }, []);

  const getDashboardList = () => {
    const listForm = {
      CoOperativeCode: userinfo?.coOperativeCode,
      BranchID: "",
      IsEncryptReq: "N",
      TimeStamp: new Date().toISOString(),
    };

    const key = CryptoJS.enc.Utf8.parse("D89035A6634F4C4786B947518F17A18A");
    const iv = CryptoJS.enc.Utf8.parse("EasyS0ftS0ftware0"); // ensure 16 bytes

    const encrypted = CryptoJS.AES.encrypt(JSON.stringify(listForm), key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    fetch(`${url}/CoOperative/DashBoarData`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Signature: apisignature,
      },
      body: JSON.stringify({ EncrytedText: encrypted.toString() }),
    })
      .then((res) => res.json())
      .then((resp) => {
        if (resp.statuS_CODE === "0") setDashboardList(resp);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "60vh" }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box>
      <Typography
        variant="h5"
        gutterBottom
        sx={{
          color: "primary.main",
          mb: 2,
          fontWeight: 700,
          fontFamily: '"Nunito", sans-serif',
          fontSize: "1.9rem",
          textShadow: "0px 2px 6px rgba(0,0,0,0.08)",
          display: "flex",
          alignItems: "center",
        }}
      >
        <DashboardCustomizeRounded sx={{ mr: 1 }} /> Dashboard Overview
      </Typography>

      <Grid container spacing={2}>
        {cardData.map((card) => (
          <Grid key={card.id} item xs={12} sm={6} md={4}>
            <Card
              sx={{
                background: card.background,
                color: "white",
                borderRadius: 3,
                boxShadow: card.boxShadow,
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
                "&:hover": {
                  transform: "translateY(-2px) scale(1.02)",
                  boxShadow: card.hoverShadow,
                },
              }}
            >
              <CardContent sx={{ p: 2, position: "relative", "&:last-child": { pb: 2 } }}>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Box
                    sx={{
                      background: "rgba(255, 255, 255, 0.25)",
                      borderRadius: "50%",
                      width: 40,
                      height: 40,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      mr: 1.5,
                    }}
                  >
                    {card.icon}
                  </Box>
                  <Typography variant="body2" sx={{ fontWeight: 600, fontSize: "0.95rem", color: "white" }}>
                    {card.title}
                  </Typography>
                </Box>
                <Typography variant="h4" sx={{ fontWeight: "bold", mb: 2, mt: 1, color: "white" }}>
                  {card.value}
                </Typography>
                <Box
                  sx={{
                    position: "absolute",
                    top: 16,
                    right: 16,
                    opacity: 0.1,
                    color: "white",
                  }}
                >
                  {card.largeIcon}
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Dashboard;
